import { ParsedReportParams, ReportBackendTypes } from '@ais-ui/websockets';
import { FilterType, ReportType } from '../../reportsTypes';

export const findFilterTypeFromReport = (
  report: ParsedReportParams | undefined,
  reportType: ReportType,
): FilterType => {
  // Special case for transit pilotage, as it always have combined filter
  if (reportType.type === ReportBackendTypes.TRANSIT_PILOTAGE) {
    return 'combined';
  }

  if (report?.params['FID']) {
    return 'normal';
  } else if (report?.params['SHPL']) {
    return 'shiplist';
  } else if (report?.params['TL'] && report.params['TL'].length > 0) {
    return 'ship';
  } else {
    return 'normal';
  }
};
